// extracted by mini-css-extract-plugin
export default {"container":"SmsVerificationButton__container--2Mx","verifiedPhone":"SmsVerificationButton__verifiedPhone--1QZ","notVerifiedPhone":"SmsVerificationButton__notVerifiedPhone--1Ry"};